import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Contact.css';

export default function Contact() {
  const [sent, setSent] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 4500);
    e.target.reset();
  };

  return (
    <section id="contact" className="contact">
      <div className="container contact-inner">
        <motion.div
          className="contact-col"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow">Let's talk</span>
          <h2 className="section-title">
            Ready to <span className="accent">power up</span>?
          </h2>
          <p className="section-lead">
            Tell us about your project — residential, commercial, or utility. Our engineers
            respond within one business day with a site assessment and indicative quote.
          </p>

          <ul className="contact-list">
            <li>
              <div className="ci-ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M4 6h16v12H4z" /><path d="M4 6l8 7 8-7" />
                </svg>
              </div>
              <div>
                <span>Email</span>
                <strong>sales@globalsunenergy.in</strong>
              </div>
            </li>
            <li>
              <div className="ci-ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M4 5c0 9 6 15 15 15l2-4-5-2-2 2a12 12 0 01-6-6l2-2-2-5-4 2z" />
                </svg>
              </div>
              <div>
                <span>Phone</span>
                <strong>+91 99118 56774</strong>
              </div>
            </li>
            <li>
              <div className="ci-ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M12 22s-7-7-7-13a7 7 0 0114 0c0 6-7 13-7 13z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
              </div>
              <div>
                <span>Office Address</span>
                <strong>F-130, Abulfazal Enclave, Okhla, Delhi - 110025</strong>
              </div>
            </li>
            <li>
              <div className="ci-ico">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M12 22s-7-7-7-13a7 7 0 0114 0c0 6-7 13-7 13z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
              </div>
              <div>
                <span>Branch Address</span>
                <strong>H. No. 654, Street No. 6, Old Mustafabad, New Delhi - 110094</strong>
              </div>
            </li>
          </ul>
        </motion.div>

        <motion.form
          className="contact-form glass"
          onSubmit={onSubmit}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <div className="field-row">
            <label className="field">
              <span>Name</span>
              <input required type="text" placeholder="Rahul Sharma" />
            </label>
            <label className="field">
              <span>Email</span>
              <input required type="email" placeholder="rahul@company.in" />
            </label>
          </div>
          <label className="field">
            <span>Project Type</span>
            <select defaultValue="">
              <option value="" disabled>Select a project type</option>
              <option>Residential rooftop</option>
              <option>Commercial &amp; Industrial</option>
              <option>Utility-scale</option>
              <option>Storage / Hybrid</option>
              <option>EV charging</option>
            </select>
          </label>
          <label className="field">
            <span>Estimated capacity</span>
            <input type="text" placeholder="e.g. 20 kW / 5 MW / unsure" />
          </label>
          <label className="field">
            <span>Tell us more</span>
            <textarea rows="4" placeholder="Location, timeline, goals…" />
          </label>

          <button type="submit" className="btn btn-primary form-submit">
            {sent ? 'Message sent — we\'ll be in touch' : 'Send Enquiry →'}
          </button>

          <p className="form-fine">We reply within 1 business day. Your data stays private.</p>
        </motion.form>
      </div>
    </section>
  );
}
